import moment from "moment";

export const copyTimeToDate = (original: Date, from: Date): Date => {
  const currentDate = moment(original);
  const copyFrom = moment(from);
  currentDate.set("hour", copyFrom.get("hour"));
  currentDate.set("minute", copyFrom.get("minute"));
  currentDate.set("second", copyFrom.get("second"));

  return currentDate.toDate();
};
